<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="code_momo"
      title="Réinitialiser mon code PIN Mobile Money"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="">
        <div class="step-one" v-if="current_step == 1">
          <h6>Choisir le mode de réinitialisation</h6>
          <div>
            <b-form-group label="" v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio
                v-model="current_mode"
                :aria-describedby="ariaDescribedby"
                name="momo_reset_mode"
                value="otp_mode"
              >
                <div>Demander un code OTP</div>
                <div class="text-muted">
                  <ul>
                    <li>Si votre solde est inférieur ou égal à 5000 FCFA</li>
                  </ul>
                </div>
              </b-form-radio>
              <b-form-radio
                v-model="current_mode"
                :aria-describedby="ariaDescribedby"
                name="momo_reset_mode"
                value="quiz_mode"
              >
                <div>Répondre à un questionnaire</div>
                <div class="text-muted">
                  <ul>
                    <li>Si votre solde est inférieur ou égal à 5000 FCFA</li>
                    <li>
                      Si vous avez déjà créé un questionnaire de récupération en
                      USSD
                    </li>
                  </ul>
                </div>
              </b-form-radio>
            </b-form-group>
            <div v-if="show_choice_error == true" class="py-2">
              <VFieldErrors
                :message="'Vous devez choisir un mode pour continuer'"
                class="w-100"
              />
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-primary"
              @click="goToNextStep()"
              :disabled="get_otp_process"
            >
              <span
                v-if="get_otp_process == true"
                class="d-flex align-items-center"
              >
                <b-spinner small></b-spinner>
                <span class="pl-1"> Traitement... </span>
              </span>
              <span v-else-if="get_otp_process == false"> Suivant </span>
            </button>
          </div>
        </div>
        <div class="step-two" v-if="current_step == 2">
          <div v-if="current_mode == 'quiz_mode'">
            <div class="w-100 alert alert-warning mt-0 font-14">
              Nous avons besoin de vérifier à travers quelques questions qu'il
              s'agit bien du propriétaire du numéro
            </div>
            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(checkQuiz)">
                <b-form-group
                  id="input-group-1"
                  :label="quizs[0].question"
                  label-for="input-1"
                  description=""
                >
                  <validation-provider v-slot="{ errors }">
                    <b-form-input
                      id="input-1"
                      v-model="form.quiz_one"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  :label="quizs[1].question"
                  label-for="input-1"
                  description=""
                >
                  <validation-provider v-slot="{ errors }">
                    <b-form-input
                      id="input-1"
                      v-model="form.quiz_two"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  :label="quizs[2].question"
                  label-for="input-1"
                  description=""
                >
                  <validation-provider v-slot="{ errors }">
                    <b-form-input
                      id="input-1"
                      v-model="form.quiz_three"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  :label="quizs[3].question"
                  label-for="input-1"
                  description=""
                >
                  <validation-provider v-slot="{ errors }">
                    <b-form-input
                      id="input-1"
                      v-model="form.quiz_four"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mb-0"
                  id="input-group-1"
                  :label="quizs[4].question"
                  label-for="input-1"
                  description=""
                >
                  <validation-provider v-slot="{ errors }">
                    <b-form-input
                      id="input-1"
                      v-model="form.quiz_five"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <VFieldErrors
                  v-if="invalid_quiz == true"
                  :message="'Vous devez répondre à au moins trois questions'"
                  class="w-100 pt-3"
                />
                <div class="d-flex justify-content-between pt-3">
                  <button
                    class="btn btn-outline-danger me-2"
                    :disabled="quiz_loading"
                    @click="previous_step()"
                  >
                    <span>Précédent</span>
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="quiz_loading"
                  >
                    <span v-if="quiz_loading == true">
                      <b-spinner small></b-spinner>
                      <span class="ms-1"> Traitement... </span>
                    </span>
                    <span v-else-if="quiz_loading == false"> Valider </span>
                  </button>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
        <div class="step-three" v-if="current_step == 3">
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(validateNewCode)">
              <b-form-group
                class="mb-0"
                id="input-group-1"
                label="Code OTP"
                label-for="input-1"
                description="Veuillez entrer le code OTP reçu par SMS"
              >
                <validation-provider v-slot="{ errors }" rules="required">
                  <b-form-input
                    id="input-1"
                    v-model="form.code_otp"
                    type="text"
                    placeholder=""
                  ></b-form-input>
                  <VFieldErrors :errors="errors" class="w-100" />
                </validation-provider>
              </b-form-group>

              <div class="d-flex justify-content-end resend mt-1 mb-2">
                <div
                  v-show="resend_loading == true"
                  class="resend-loader spinner-border"
                  role="status"
                />
                <a
                  href="#"
                  v-show="resend_loading == false"
                  @click="resend_otp"
                >
                  Renvoyer le code</a
                >
              </div>
              <b-form-group
                id="input-group-1"
                label="Nouveau code momo"
                label-for="input-1"
                description="Code à 5 chiffres"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|digits:5"
                  vid="form.new_code"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.new_code"
                    type="password"
                    placeholder="Entrer le nouveau code"
                  ></b-form-input>
                  <VFieldErrors :errors="errors" class="w-100" />
                </validation-provider>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                label="Confirmer le code"
                label-for="input-1"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|digits:5|confirmed:form.new_code"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.confirm_code"
                    type="password"
                    placeholder="Confirmer le nouveau code"
                  ></b-form-input>
                  <VFieldErrors :errors="errors" class="w-100" />
                </validation-provider>
              </b-form-group>
              <div class="d-flex justify-content-between">
                <button
                  class="btn btn-outline-danger me-2"
                  :disabled="new_code_loading"
                  @click="current_step = 1"
                >
                  <span>Précédent</span>
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="new_code_loading || cant_continue"
                >
                  <span
                    v-if="new_code_loading == true"
                    class="d-flex align-items-center"
                  >
                    <b-spinner small class="me-1"></b-spinner>
                    <span class="pl-1"> Traitement... </span>
                  </span>
                  <span v-else-if="new_code_loading == false"> Valider </span>
                </button>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
        <div
          class="step-finish text-center modal-success-error-message"
          v-if="current_step == 4"
        >
          <i class="mdi mdi-check"></i>
          <p class="text-muted">
            <b>Changement éffectué.</b> <br />
            Votre code PIN Mobile Money a été changé avec succès.
          </p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import VFieldErrors from "@/components/utils/VFieldsErrors";
import { required, length, digits, confirmed } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import { subscriber } from "@/services";
extend("required", {
  ...required,
  message: "Champ obligatoire",
});
extend("digits", {
  ...digits,
  message: "Vous devez entrer un code à 5 chiffres",
});
extend("confirmed", {
  ...confirmed,
  message: "Les deux codes ne correspondent pas.",
});
export default {
  name: "",
  components: {
    VFieldErrors,
  },
  created: async function () {
    this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
      if (modalId == "code_momo") {
        this.current_step = 1;
        (this.current_mode = ""),
          (this.get_otp_process = false),
          (this.show_choice_error = false),
          (this.invalid_otp = false),
          (this.invalid_quiz = false),
          (this.quiz_loading = false),
          (this.otp_loading = false),
          (this.new_code_loading = false);
        this.form = {
          code_otp: "",
          new_code: "",
          confirm_code: "",
          quiz_one: "",
          quiz_two: "",
          quiz_three: "",
          quiz_four: "",
          quiz_five: "",
        };
        this.cant_continue = false;
        // await subscriber.getPinResetMomoQuiz().then((response) => {
        //   this.quizs = response.questions;
        // });
      }
    });
  },
  data: () => {
    return {
      current_step: 1,
      current_mode: "",
      get_otp_process: false,
      show_choice_error: false,
      invalid_otp: false,
      invalid_quiz: false,
      quiz_loading: false,
      otp_loading: false,
      new_code_loading: false,
      resend_loading: false,
      quizs: [],
      form: {
        code_otp: "",
        new_code: "",
        confirm_code: "",
        quiz_one: "",
        quiz_two: "",
        quiz_three: "",
        quiz_four: "",
        quiz_five: "",
      },
      cant_continue: false,
    };
  },
  methods: {
    async resend_otp() {
      this.resend_loading = true;
      await subscriber.getMomoPinResetOtp().then((response) => {
        this.resend_loading = false;
        if (!response.error) {
          this.cant_continue = false;
        }
      });
    },
    next_step() {
      return this.current_step++;
    },
    previous_step() {
      return this.current_step--;
    },
    async goToNextStep() {
      if (this.current_mode.trim() !== "" && this.current_mode !== undefined) {
        this.show_choice_error = false;
        if (this.current_mode == "otp_mode") {
          this.get_otp_process = true;
          await subscriber.getMomoPinResetOtp().then((response) => {
            this.get_otp_process = false;
            if (response && response.success == true) {
              this.current_step = 3;
            }
          });
        } else {
          this.next_step();
        }
      } else {
        this.show_choice_error = true;
      }
    },
    checkOtp() {
      this.invalid_otp = false;
      this.otp_loading = true;
      setTimeout(() => {
        this.otp_loading = false;
        this.invalid_otp = false;
        this.next_step();
      }, 2500);
    },
    async checkQuiz() {
      const data = {
        questions_responses: [
          {
            question_id: 1,
            answer: this.form.quiz_one,
          },
          {
            question_id: 2,
            answer: this.form.quiz_two,
          },
          {
            question_id: 3,
            answer: this.form.quiz_three,
          },
          {
            question_id: 4,
            answer: this.form.quiz_four,
          },
          {
            question_id: 5,
            answer: this.form.quiz_five,
          },
        ],
      };
      const check_validation = data.questions_responses.filter(
        (res) => res.answer.trim() !== ""
      );
      if (check_validation.length < 3) {
        this.invalid_quiz = true;
        return;
      } else {
        this.quiz_loading = true;
        this.invalid_quiz = false;
        await subscriber.verifyQuestionsResponses(data).then((resp) => {
          this.quiz_loading = false;
          if (resp.success) {
            this.next_step();
          }
        });
      }
    },
    async validateNewCode() {
      this.cant_continue = false;
      const data = {
        otp: this.form.code_otp,
        new_secret: this.form.new_code,
      };
      this.new_code_loading = true;
      await subscriber.sendNewCodeMomo(data).then((resp) => {
        this.new_code_loading = false;
        if (resp.success !== undefined && resp.success == true) {
          this.next_step();
        } else {
          this.cant_continue = true;
        }
      });
    },
  },
  watch: {
    // async "$store.state.core.subscriber.infos"() {
    //   await subscriber.getPinResetMomoQuiz().then((response) => {
    //     this.quizs = response.questions;
    //   });
    // },
  },
};
</script>
<style scoped>
.description {
  font-size: 12px !important;
}
ul {
  font-size: 12px !important;
  padding-left: 16px !important;
}
.alert {
  font-size: 14px !important;
  padding: 4px 12px !important;
}
::v-deep .modal-body {
  overflow-y: auto !important;
  max-height: 450px !important;
}
.resend a {
  font-size: 14px !important;
  text-decoration: underline !important;
}
.resend-loader.spinner-border {
  width: 18px !important;
  height: 18px !important;
  color: #fc0 !important;
}
</style>